/**
 * @file
 * Mapbox code for "mijn omgeving" page.
 */

import 'polyfill-array-includes';
import explode from '@turf/explode';
import { belgiumBounds, mapboxAccessToken } from '../../utils/MapUtils';

(Drupal => {
  Drupal.behaviors.scrollToResultsAfterWorkSearch = {
    attach(context, settings) {
      let urlParams = new URLSearchParams(window.location.search);

      let paramsString = urlParams.toString();

      if (
        paramsString.includes('source_configuration') &&
        paramsString.includes('proximity')
      ) {
        let element = document.getElementById(
          'views-exposed-form-jobs-job-search',
        );

        if (element) {
          element.scrollIntoView();
        }
      }
    },
  };
})(Drupal);
(($, Drupal, mapboxgl) => {
  Drupal.behaviors.mapsInit = {
    attach(context, settings) {
      if (!$('#jobResultMap', context).length) {
        return;
      }
      const nids = settings.ids;

      let JSONurl = '/jobs/map/json';

      if (nids !== undefined) {
        JSONurl = `/jobs/map/json/${nids}`;
      }

      const clusterRadius = 10;

      $('.job--overview-controls > .toggle-container').on('click', () => {
        $('.toggle--icon').toggleClass('icon-map icon-list');
        $('.toggle--map').toggleClass('visible');
        $('.toggle--list').toggleClass('visible');
        $('.job--overview-map').toggleClass('hidden');
        $('.job--overview-teaser').toggleClass('hidden');
        mapboxgl.accessToken = mapboxAccessToken;
        const map = new mapboxgl.Map({
          container: 'jobResultMap',
          style:
            'mapbox://styles/didmapboxfrederik/ciz02ulow00032rnsyzqba92c?optimize=true',
          center: [4.1072426, 51.0925963],
          zoom: 8,
          maxZoom: 18,
          maxBounds: belgiumBounds,
        });

        let exploded;
        const loadJSONData = () => {
          $.ajax({
            url: JSONurl,
            context: document.body,
            dataType: 'json',
            success: data => {
              exploded = explode(data);
            },
            complete: () => {
              loadMapData();
            },
            error: error => {
              alert('error; ' + eval(error));
            },
          });
        };

        const loadMapData = () => {
          map.on('load', () => {
            map.addSource('jobLocations', {
              type: 'geojson',
              data: exploded,
              cluster: true,
              clusterRadius: clusterRadius,
              clusterMaxZoom: 24,
            });

            map.addLayer({
              id: 'jobLocations',
              type: 'circle',
              source: 'jobLocations',
              filter: ['==', 'category', 'multi'],
              interactive: true,
              paint: {
                'circle-color': '#FFA500',
                'circle-radius': 16,
                'circle-stroke-width': 8,
                'circle-stroke-color': '#fff',
                'circle-stroke-opacity': 0.85,
              },
            });

            map.addLayer({
              id: 'jobAreas',
              type: 'circle',
              source: 'jobLocations',
              filter: ['==', 'category', 'single'],
              interactive: true,
              paint: {
                'circle-color': '#B9D216',
                'circle-radius': 16,
                'circle-stroke-width': 8,
                'circle-stroke-color': '#fff',
                'circle-stroke-opacity': 0.85,
              },
            });

            map.addLayer({
              id: 'jobClusters',
              source: 'jobLocations',
              type: 'circle',
              filter: ['has', 'point_count'],
              interactive: true,
              paint: {
                'circle-radius': {
                  property: 'point_count',
                  stops: [
                    [0, 16],
                    [1, 16],
                    [2, 20],
                    [5, 24],
                    [10, 28],
                    [20, 32],
                    [50, 36],
                    [100, 40],
                    [200, 44],
                    [99999, 16], // "default" doesn't work in this api version -> use high number to set a default
                  ],
                },
                'circle-color': {
                  property: 'point_count',
                  stops: [
                    [0, '#B9D216'],
                    [1, '#B9D216'],
                    [2, '#ffffff'],
                    [99999, '#B9D216'], // "default" doesn't work in this api version -> use high number to set a default
                  ],
                },
                'circle-stroke-width': {
                  property: 'point_count',
                  stops: [
                    [0, 8],
                    [1, 8],
                    [2, 4],
                    [99999, 8], // "default" doesn't work in this api version -> use high number to set a default
                  ],
                },
                'circle-stroke-color': {
                  property: 'point_count',
                  stops: [
                    [0, '#ffffff'],
                    [1, '#ffffff'],
                    [2, '#4bb8f4'],
                    [99999, '#ffffff'], // "default" doesn't work in this api version -> use high number to set a default
                  ],
                },
                'circle-stroke-opacity': 0.85,
              },
            });

            map.addLayer({
              id: 'jobs-count',
              type: 'symbol',
              source: 'jobLocations',
              filter: ['has', 'point_count'],
              interactive: true,
              layout: {
                'text-field': '{point_count_abbreviated}',
                'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
                'text-size': 12,
              },
            });

            map.on('click', ev => {
              const isCluster = map.queryRenderedFeatures(ev.point, {
                layers: ['jobClusters'],
              });
              const isMarker = map.queryRenderedFeatures(ev.point, {
                layers: ['jobAreas', 'jobLocations'],
              });

              if (isCluster.length) {
                map.flyTo({
                  center: [ev.lngLat.lng, ev.lngLat.lat],
                  zoom: Math.min(map.getMaxZoom(), map.getZoom() + 2),
                });

                const jobsInCluster = exploded.features.filter(e => {
                  const pointPixels = map.project(e.geometry.coordinates);
                  const pixelDistance = Math.sqrt(
                    Math.pow(ev.point.x - pointPixels.x, 2) +
                      Math.pow(ev.point.y - pointPixels.y, 2),
                  );
                  return Math.abs(pixelDistance) <= clusterRadius;
                });

                if (jobsInCluster.length) {
                  const reflat = jobsInCluster[0].geometry.coordinates[0];
                  const reflong = jobsInCluster[0].geometry.coordinates[1];
                  const sameLocation = jobsInCluster.filter(point => {
                    if (
                      reflat === point.geometry.coordinates[0] &&
                      reflong === point.geometry.coordinates[1]
                    ) {
                      return point;
                    }
                  });
                  console.log(sameLocation);

                  if (
                    isCluster[0].properties.point_count === sameLocation.length
                  ) {
                    let content = '';
                    sameLocation.filter(e => {
                      content += `<a href="${e.properties.link}"><span class="${
                        e.properties.category
                      }"></span>${e.properties.title}</a>`;
                    });
                    new mapboxgl.Popup({ closeButton: false })
                      .setLngLat(sameLocation[0].geometry.coordinates)
                      .setHTML(content)
                      .addTo(map);
                    return;
                  }
                }
                return;
              }

              if (isMarker.length) {
                map.flyTo({
                  center: [ev.lngLat.lng, ev.lngLat.lat],
                  zoom: Math.min(map.getMaxZoom(), map.getZoom() + 2),
                });
                new mapboxgl.Popup({ closeButton: false })
                  .setLngLat(isMarker[0].geometry.coordinates)
                  .setHTML(
                    `
                      <a href="${isMarker[0].properties.link}">
                        ${isMarker[0].properties.title}
                      </a>
                  `,
                  )
                  .addTo(map);
                return;
              }
            });

            map.on('mousemove', e => {
              const jobsLoc = map.getLayer('jobLocations')
                ? map.queryRenderedFeatures(e.point, {
                    layers: ['jobLocations'],
                  })
                : [];
              const jobAreas = map.getLayer('jobAreas')
                ? map.queryRenderedFeatures(e.point, { layers: ['jobAreas'] })
                : [];
              const jobClusters = map.getLayer('jobClusters')
                ? map.queryRenderedFeatures(e.point, {
                    layers: ['jobClusters'],
                  })
                : [];
              if (
                jobsLoc.length !== 0 ||
                jobAreas.length !== 0 ||
                jobClusters.length !== 0
              ) {
                map.getCanvas().style.cursor = 'pointer';
              } else {
                map.getCanvas().style.cursor = '';
              }
            });
          });
        };

        loadJSONData();
      });
    },
  };
})(jQuery, Drupal, mapboxgl);
